/* eslint-disable */
import ImageInput from './ImageInput';

export default ImageInput;
